import { api } from '@/scripts/api';

export const MDFAgencyRequestService = {
    getById(accountId, fundRequestId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-requests/vendor-account/${accountId}/requests/${fundRequestId}`;

            api.get(service)
                .then(resolve)
                .catch(reject);
        });
    },

    post(accountId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-requests/vendor-account/${accountId}/requests`;

            api.post(service, payload)
                .then(resolve)
                .catch(reject);
        });
    },
}
